import {Form} from 'antd';
import {FormInstance} from 'antd/es/form';
import cn from 'classnames';
import React, {FC} from 'react';

import {CustomSelect} from 'components/form/inputs/custom-select';
import './setting-template-transfer-target-filter.less';
import {useAppDispatch} from 'store/config/hooks';
import {
    loadSettingTemplateTargetColumns,
} from 'store/slices/document-upload-template/document-upload-template-slice-thunks';

import {EWatcherFieldFlag} from '../../../../../report-configuration/hooks/use-form-fields-manager';
import {ESettingTemplateTransferTargetFormFields} from '../../constants/setting-template-transfer-target/setting-template-transfer-target';

interface ISettingTemplateTransferTargetProps {
    form: FormInstance;
  checkArrayIndependentWatcherFlag: (
    fieldKey: string,
    flag: EWatcherFieldFlag
  ) => boolean;
}
export const SettingTemplateTransferTargetFilter: FC<ISettingTemplateTransferTargetProps> = (
    {checkArrayIndependentWatcherFlag, form}: ISettingTemplateTransferTargetProps,
) => {
    const dispatch = useAppDispatch();
    const handleChangeFilter = (sublistAttributeOne: string, sublistAttributeTwo: string) => {
        if (sublistAttributeOne && sublistAttributeTwo) {
            dispatch(loadSettingTemplateTargetColumns({sublistCode: sublistAttributeTwo}));
        }
    };
    return (
        <div className={cn('setting-template-transfer-target-filter')}>
            <Form.Item
                name={ESettingTemplateTransferTargetFormFields.SOURCE_TABLE}
                style={{width: 245}}
                label="Исходная таблица"
                rules={[{required: true}]}
            >
                <CustomSelect
                    handleTriggerEvent={value => {
                        handleChangeFilter(
                            value?.meaning,
                            form?.getFieldValue(ESettingTemplateTransferTargetFormFields.TARGET_TABLE),
                        );
                    }}
                    settings={{
                        showSearch: true,
                        placeholder: 'Выберите тип поля',
                        url: '/lookupValue/PROGRAM_SETTING_SOURCE_TABLE',
                        isDisabled: checkArrayIndependentWatcherFlag(
                            ESettingTemplateTransferTargetFormFields.SOURCE_TABLE,
                            EWatcherFieldFlag.isDisabled,
                        ),
                        labelPath: 'meaning',
                        valuePath: 'meaning',
                    }}
                />
            </Form.Item>
            <Form.Item
                name={ESettingTemplateTransferTargetFormFields.TARGET_TABLE}
                style={{width: 245}}
                label="Целевая таблица"
                rules={[{required: true}]}
            >
                <CustomSelect
                    handleTriggerEvent={value => {
                        handleChangeFilter(
                            form?.getFieldValue(ESettingTemplateTransferTargetFormFields.SOURCE_TABLE),
                            value?.meaning,
                        );
                    }}
                    settings={{
                        showSearch: true,
                        isDisabled: checkArrayIndependentWatcherFlag(
                            ESettingTemplateTransferTargetFormFields.SOURCE_TABLE,
                            EWatcherFieldFlag.isDisabled,
                        ),
                        placeholder: 'Выберите тип поля',
                        url: '/lookupValue/PROGRAM_SETTING_TARGET_TABLE',
                        labelPath: 'meaning',
                        valuePath: 'description',
                    }}
                />
            </Form.Item>
        </div>
    );
};
